import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

import Button from "@material-ui/core/Button";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Grid from "@material-ui/core/Grid";

import { resetError } from "../../actions/redirect";
import AdapterLink from "../AdapterLink";
import Bank from "./bank/Bank";
import CardForm from "./card/CardForm";
import Upi from "./upi/UpiForm";
import PaymentInfo from "./info/PaymentInfo";
import PaymentList from "./list/PaymentList";
import SavedCard from "./savedcard/SavedCard";
import Redirection from "../redirection/Redirection";
import WalletForm from "./wallet/WalletForm";
import WarningMessage from "../common/WarningMessage";

import "./PaymentForm.css";

export const PaymentForm = ({
  match,
  charge,
  redirecting,
  redirectError,
  redirectParams,
  dispatch
}) => {
  const paymentSchemes = [
    {
      path: "savedcard",
      name: "Saved Card(s)",
      component: <SavedCard charge={charge} />
    },
    { path: "card", name: "Card", component: <CardForm charge={charge} /> },
    { path: "ib", name: "Netbanking", component: <Bank charge={charge} /> },
    { path: "upi", name: "UPI", component: <Upi charge={charge} /> },
    {
      path: "wallet",
      name: "Wallet",
      component: <WalletForm charge={charge} />
    },
    { path: "emi", name: "EMI", component: "TODO" }
  ];

  const wrapScheme = (name, component) => {
    return (
      <Grid container direction="column" className="payment-form-item">
        <Grid item className="back-to-list">
          <Button
            onClick={() => dispatch(resetError())}
            component={AdapterLink}
            to={match.url}
          >
            <ChevronLeftIcon />
            {name}
          </Button>
        </Grid>
        <Grid
          item
          className={`payment-form-scheme ${
            name === "Saved Card(s)" ? "payment-saved-card-form-scheme" : ""
          }`}
        >
          {!!redirectError && (
            <div className="error-message">
              <WarningMessage
                message={redirectError}
                closeAction={() => dispatch(resetError())}
              />
            </div>
          )}
          {component}
        </Grid>
      </Grid>
    );
  };

  const animate = (routeMatch, className, renderFn) => {
    return (
      <CSSTransition
        in={routeMatch != null}
        timeout={300}
        classNames={className}
        unmountOnExit
      >
        <div className="payment-form-item">{renderFn()}</div>
      </CSSTransition>
    );
  };

  const parentMatch = match;
  const shouldDisplayWarning = charge.attempts > 0;

  return (
    <div className="payment-form">
      <Grid item lg>
        <PaymentInfo charge={charge} />
      </Grid>
      <Grid container className="payment-form-body" direction="row">
        <Route path={match.path} exact>
          {({ match: childMatch }) =>
            animate(childMatch, "to-left", () => (
              <div>
                {shouldDisplayWarning && (
                  <WarningMessage
                    style={{ margin: "20px" }}
                    message="Payment has failed. Try a different payment option."
                  />
                )}
                <PaymentList match={parentMatch} charge={charge} />
              </div>
            ))
          }
        </Route>
        {paymentSchemes.map(scheme => {
          return (
            <Route key={scheme.path} path={`${match.path}/${scheme.path}`}>
              {({ match: childMatch }) =>
                animate(childMatch, "to-right", () =>
                  wrapScheme(scheme.name, scheme.component)
                )
              }
            </Route>
          );
        })}
      </Grid>
      {redirectParams && redirecting ? (
        <Redirection charge={charge} {...redirectParams} />
      ) : (
        <span />
      )}
    </div>
  );
};

PaymentForm.propTypes = {
  charge: PropTypes.shape().isRequired,
  redirecting: PropTypes.bool.isRequired,
  match: PropTypes.shape().isRequired,
  redirectParams: PropTypes.shape(),
  redirectError: PropTypes.string,
  dispatch: PropTypes.func.isRequired
};

PaymentForm.defaultProps = {
  redirectParams: undefined,
  redirectError: undefined
};

function mapStateToProps({ redirectionReducer }) {
  return redirectionReducer;
}

export default connect(mapStateToProps)(PaymentForm);
